import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChallengeTypeTag.scss';

const ChallengeTypeTag = ({ challengeType, completed = false, size = 'default' }) => {
  const { t } = useTranslation(['chatbot']);

  // Map challenge types to translation keys
  const getChallengeTypeTranslation = (type) => {
    const typeMap = {
      new: 'student_recommendations_challenge_type_new',
      review: 'student_recommendations_challenge_type_review',
      combo: 'student_recommendations_challenge_type_combo',
      improvement: 'student_recommendations_challenge_type_improvement',
    };
    return t(typeMap[type] || 'student_recommendations_challenge_type_new');
  };

  // Generate CSS class based on challenge type
  const getChallengeTypeClass = (type) => {
    if (!type) return 'challenge-type-tag--new';
    return `challenge-type-tag--${type.toLowerCase().replace(/\s+/g, '-')}`;
  };

  if (!challengeType) {
    return null;
  }

  return (
    <span
      className={clsx('challenge-type-tag', getChallengeTypeClass(challengeType), `challenge-type-tag--${size}`, {
        done: completed,
      })}
    >
      {getChallengeTypeTranslation(challengeType)}
    </span>
  );
};

ChallengeTypeTag.propTypes = {
  challengeType: PropTypes.oneOf(['new', 'review', 'combo', 'improvement']),
  completed: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
};

export default ChallengeTypeTag;
